/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const setTargetLoopRequestSchema = z.object({
  targetLoopId: z.int().nullish(),
});
